<aio-toast-outlet />
<div
  class="app-root"
  [class.with-layout]="showLayout"
  [class.mobile-nav-open]="mobileNavOpen()">
  @if (showLayout) {
    <app-topbar
      [pageName]="pageTitle"
      [userInitials]="userInitials"
      [userName]="userName"
      [userEmail]="userEmail"
      [userRole]="userRole"
      [userProfilePicture]="userProfilePicture"
      [sidebarCollapsed]="topbarCollapsed()"
      [showNotifications]="showNotifications"
      (signOut)="signOut()"
      (profileSettings)="profileSettings()"
      (adminPortal)="adminPortal()"
      (toggleSidebar)="toggleSidebar()"
    ></app-topbar>
  }
  <div class="main-content">
    @if (showLayout) {
      <app-sidebar
        [sidebarCollapsed]="isMobile() ? false : sidebarCollapsed"
        (expandSidebar)="toggleSidebar()"
      ></app-sidebar>
      @if (isMobile() && mobileNavOpen()) {
        <button type="button" class="mobile-nav-backdrop" aria-label="Close menu" (click)="closeMobileNav()"></button>
      }
    }
    <div class="content-area" [class.sidebar-collapsed]="sidebarCollapsed">
      <router-outlet></router-outlet>
      @if (showLayout) {
        <!-- Inside the content area on purpose: the area is position: fixed, so it is a stacking
             context and everything in it paints at one level. A launcher outside it would sit above
             every dropdown and popover the pages open (Add Lead's Referral Source list, for one).
             The assistant's drawer re-parents itself to <body>, so only the launcher button lives here. -->
        <app-chat-buddy />
      }
    </div>
  </div>
  @if (showLayout && profileSettingsModalOpen()) {
    <app-profile-settings-modal (closed)="closeProfileSettingsModal()" />
  }
</div>
